/**
 * CumparaCu — "Cumpără cu" carousel widget
 * ES6 class, BEM-aware, Shopify cart API (AJAX add to cart).
 */
class CumparaCu {
  constructor(el) {
    this._el        = el;
    this._track     = el.querySelector('[data-cpc-track]');
    this._slides    = Array.from(el.querySelectorAll('[data-cpc-slide]'));
    this._prevBtn   = el.querySelector('[data-cpc-prev]');
    this._nextBtn   = el.querySelector('[data-cpc-next]');
    this._current   = 0;
    this._total     = this._slides.length;

    this._bindEvents();
    this._updateNav();
  }

  // —— Carousel ————————————————————————————————————————————————

  _goTo(index) {
    this._current = Math.max(0, Math.min(index, this._total - 1));
    this._track.style.transform = `translateX(-${this._current * 100}%)`;
    this._updateNav();
  }

  _updateNav() {
    if (this._prevBtn) this._prevBtn.disabled = this._current === 0;
    if (this._nextBtn) this._nextBtn.disabled = this._current === this._total - 1;
  }

  // —— Money formatting ————————————————————————————————————————

  _formatMoney(cents) {
    const fmt = window.spratlyThemeSettings && window.spratlyThemeSettings.money_format;
    if (window.Shopify && window.Shopify.formatMoney && fmt) {
      return window.Shopify.formatMoney(cents, fmt);
    }
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2 }).format(cents / 100) + ' lei';
  }

  // —— Add to cart —————————————————————————————————————————————

  async _addToCart(btn) {
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data  = await res.json();
      const added = data.items || [];

      // Trigger theme cart drawer
      if (window.Shopify && window.Shopify.onItemAdded && added.length) {
        window.Shopify.onItemAdded(added[0]);
      }

      // Visual feedback
      btn.classList.add('cpc__add-btn--added');
      setTimeout(() => btn.classList.remove('cpc__add-btn--added'), 1500);

    } catch (err) {
      console.error('[CumparaCu] addToCart error:', err);
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  // —— Events ——————————————————————————————————————————————————

  _bindEvents() {
    if (this._prevBtn) {
      this._prevBtn.addEventListener('click', () => this._goTo(this._current - 1));
    }
    if (this._nextBtn) {
      this._nextBtn.addEventListener('click', () => this._goTo(this._current + 1));
    }

    this._el.querySelectorAll('[data-cpc-add]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._addToCart(btn);
      });
    });
  }
}

// —— Auto-init ——————————————————————————————————————————————————

(function initCumparaCu() {
  document.querySelectorAll('[data-cpc]').forEach(el => {
    if (!el._cpcInstance) {
      el._cpcInstance = new CumparaCu(el);
    }
  });
})();
